import React, { useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { TextField } from '@mui/material'
import moment from 'moment'

const InvehicleRecordingsFilterDropdown = ({filters, setFilters, onApply, handleResetFilters, activeTab}) => {

  const handleChange = (field, value) => {
    setFilters((prev) => ({ ...prev, [field]: value }));
  };

  return (
    <div
      className="w-[350px] px-[30px] py-[20px] text-[#000000] font-Poppins"
      style={{
        background:
          'transparent linear-gradient(90deg, #FFFFFF 0%, #D6D8FF 100%) 0% 0% no-repeat padding-box',
        boxShadow: '4px 4px 6px #00000029',
        border: '2px solid #B05DC6',
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="w-full flex flex-col gap-[15px]">
        {/* Name */}
        <p className="text-[16px] font-semibold">Learner Name</p>

        <input
          type="text"
          placeholder="Enter Name"
          value={filters.LearnerName}
          onChange={(e) => handleChange('LearnerName', e.target.value)}
          style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          paddingBottom: '4px',
          color: '#000000',
          fontSize: '16px',
          boxShadow: 'none',
        }}
        />

        {/* Name */}
        <p className="text-[16px] font-semibold">Instructor Name</p>

        <input
          type="text"
          placeholder="Enter Name"
          value={filters.InstructorName}
          onChange={(e) => handleChange('InstructorName', e.target.value)}
          style={{
          backgroundColor: 'transparent',
          border: 'none',
          outline: 'none',
          borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
          paddingBottom: '4px',
          color: '#000000',
          fontSize: '16px',
          boxShadow: 'none',
        }}
        />

         {/* Date */}
         <p className="text-[16px] font-semibold">Select Date</p>
         <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
            closeOnSelect={false}
            value={filters.RecordingDate || null}
            onChange={(newValue) => {
            if (newValue && moment(newValue).isValid()) {
                handleChange('RecordingDate', moment(newValue));
            } else {
                handleChange('RecordingDate', null);
            }
            }}
            format="DD/MM/YYYY"
            renderInput={(params) => (
                <TextField
                {...params}
                fullWidth
                sx={{
                    '& .MuiOutlinedInput-root': {
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 0px 6px #00000029',
                    border: '1px solid #E2E2E2',
                    opacity: 1,
                    '& fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&:hover fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    '&.Mui-focused fieldset': {
                        borderColor: '#E2E2E2',
                    },
                    },
                }}
                inputProps={{
                    ...params.inputProps,
                    readOnly: true,
                }}
                />
            )}
            />
        </LocalizationProvider>

        {/* Sort Order */}
        <p className="text-[16px] font-semibold">Sort Recordings</p>
        <select
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            outline: 'none',
            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
            paddingBottom: '4px',
            color: '#000000',
            fontSize: '14px',
            WebkitAppearance: 'none', // disables default styling in WebKit
            MozAppearance: 'none',    // disables default styling in Firefox
          }}
          value={filters.sortOrder}
          onChange={(e) => handleChange('sortOrder', e.target.value)}
        >
          <option value="">Select</option>
          <option value="desc">New to Old</option>  {/* latest first */}
          <option value="asc">Old to New</option>   {/* oldest first */}
        </select>

        {/* Buttons */}
        <button
          className="w-full h-[49px] mt-2 py-2 text-white rounded font-Poppins text-[16px] cursor-pointer"
          style={{
            background: 'transparent linear-gradient(90deg, #B05BC5 0%, #AEAFFE 100%) 0% 0% no-repeat padding-box',
            boxShadow: '0px 15px 30px #43425D1A'
          }}
          onClick={onApply} // <- trigger parent filter logic
        >
          <img
            src={
                  require("../Assets/searchIcon.svg")
                      .default
              }
            alt="search"
            className="absolute left-[50px] w-[20px] h-[20px]" // adjust size/margin if needed
          />
          Apply Filters
        </button>
        <p className="text-center text-[16px] text-[#A1A3EF] cursor-pointer" onClick={handleResetFilters}>Reset</p>
      </div>
    </div>
  );
};

export default InvehicleRecordingsFilterDropdown;
